import { render, staticRenderFns } from "./surchargeFclForm.vue?vue&type=template&id=888c377c&scoped=true&"
import script from "./surchargeFclForm.vue?vue&type=script&lang=js&"
export * from "./surchargeFclForm.vue?vue&type=script&lang=js&"
import style1 from "./surchargeFclForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888c377c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('888c377c')) {
      api.createRecord('888c377c', component.options)
    } else {
      api.reload('888c377c', component.options)
    }
    module.hot.accept("./surchargeFclForm.vue?vue&type=template&id=888c377c&scoped=true&", function () {
      api.rerender('888c377c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/SurchargeFCL/components/surchargeFclForm.vue"
export default component.exports